module.exports = __webpack_public_path__ + "img/paused_light.a0aeb8fe.svg";